/**
 * @file Pod related actions
 * @author Alwyn Tan
 */

import { createAction } from 'redux-actions'

export const getSuperpod = createAction('GET_SUPERPOD')
export const updateSuperpodDetails = createAction('UPDATE_SUPERPOD_DETAILS')
